module.exports = __webpack_public_path__ + "img/TTB_ECare_Card_02@2x.png";